import React, { useContext } from 'react';

import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';
import {
  ActionTypes,
  CreateCustomFieldPayloadOperations,
  CreateCustomFieldsDispatch,
} from '@components/asset/modal/tabs/edit/EditTabTypes';
import { CreateCustomFieldParams } from '@/api/v4/assets/customFieldTypes';

interface AddCustomFieldProps {
  createCustomFieldMaps: CreateCustomFieldParams[];
}

interface AddCustomFieldScopedContext {
  state: {
    editState: AddCustomFieldProps;
  };
  dispatch: CreateCustomFieldsDispatch;
}

const AddCustomField = (): JSX.Element => {
  const { state, dispatch }: AddCustomFieldScopedContext = useContext(assetModalContext);

  const createCustomFieldMap = (): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CreateCustomFieldPayloadOperations.Create }
    });
  };

  const updateCustomFieldMap = ({ index, key, value }: { index: number; key: string; value: string }): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CreateCustomFieldPayloadOperations.Update, index, key, value }
    });
  };

  const deleteCustomFieldMap = ({ index }: { index: number }): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CreateCustomFieldPayloadOperations.Delete, index }
    });
  };

  return (
    <div className="add-custom-field-container">
      <button
        className="add-custom-field-row"
        type="button"
        onClick={(): void => createCustomFieldMap()}
      >
        <span className="bff-plus" />
        {t('Add Custom Field')}
      </button>
      <ul className="custom-field-list new-custom-fields-list">
        {
          state.editState.createCustomFieldMaps.map((customField: CreateCustomFieldParams, index: number) => (
            <li
              className="custom-field-row"
              key={`new-custom-field-${index}`}
            >
              <div className="custom-field-key">
                <input
                  className="custom-field-input"
                  aria-label="Custom Field Key"
                  onChange={(e: InputChangeEvent): void => updateCustomFieldMap(
                    { key: e.currentTarget.value, index, value: customField.value }
                  )}
                  value={customField.key}
                  placeholder={t('Key')}
                />
              </div>
              <div className="custom-field-value">
                <input
                  className="custom-field-input"
                  aria-label="Custom Field Value"
                  onChange={(e: InputChangeEvent): void => updateCustomFieldMap(
                    { value: e.currentTarget.value, index, key: customField.key }
                  )}
                  value={customField.value}
                  placeholder={t('Value')}
                />
                <button
                  type="button"
                  aria-label="Remove Custom Field Row"
                  className="remove-custom-field-row"
                  onClick={(): void => deleteCustomFieldMap({ index })}
                >
                  <span className="bff-close" />
                </button>
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

export default AddCustomField;
